import React, { useEffect, lazy, Suspense, useRef, useState } from 'react';
import axios from 'axios';
import AppHeader from './components/header/app.header';
import AppFooter from './components/footer/app.footer';
import AppAboutus from './pages/aboutus/app.aboutus';
import AppServices from './pages/services/app.services';
import AppContactus from './pages/contactus/app.contactus';
import {BrowserRouter as Router, Switch, Route} from "react-router-dom";
import './App.scss';
// import appConfig from './config/config';
import Data from './constant/data.json'
import OurProject from './pages/project/app.project';
const AppLanding = lazy(() => import ('./home/app.landing'));
export const App = () =>{
  const [projectData, setProjectData] = useState([]);

  // Per Pages call
  useEffect(() => {
    const url = `http://compactitsolutions.com/wordpress/wp-json/wp/v2/pages`
    axios.get(url)
      .then(res => setProjectData(
        res.data[0].content
      ))
      .catch(err => console.error(err));
    }, [])
    
  console.log(projectData,'apiData 1')
    return (
      <Router>
        <Suspense fallback={<div className="loading">Loading...</div>}>
          <AppHeader/>
          <div className="ui-content">
            <Switch>
              <Route path="/about">
                <AppAboutus AboutUs={Data.AboutUs}/>
              </Route>
              <Route path="/services">
                <AppServices ServicesList={Data.ServicesList}/>
              </Route>
              <Route path="/projects">
                <OurProject OurProject={Data.OurProject} projectData={projectData}/>
              </Route>
              <Route path="/contact">
                <AppContactus ContactUs={Data.ContactUs}/>
              </Route>
              <Route path="/">
                <AppLanding data={Data} projectData={projectData} />
              </Route>
            </Switch>
          </div>
          <AppFooter/>
        </Suspense>
      </Router>
    );
}

export default App;